module.exports = __webpack_public_path__ + "static/mo47-b286692f41ca91a7737ff11177f50735.png";